import { GetRecordByIdResult } from '@indigohive/cogfy-types/endpoints/getRecordById'
import { GetCollectionFieldsResultData } from '@indigohive/cogfy-types/endpoints/getCollectionFields'
import { TextRecordProperty, UUID } from '@indigohive/cogfy-types'
import { UpdateRecordPropertiesOperationData } from '@indigohive/cogfy-types/endpoints/transactions'
import { useEffect, useState } from 'react'
import clsx from 'clsx'

export type TextRecordPropertyInputProps = {
  collectionId: UUID
  field: Extract<GetCollectionFieldsResultData, { type: 'text' }>
  record: GetRecordByIdResult
  onUpdateRecordProperties?: (data: UpdateRecordPropertiesOperationData) => void
  disabled?: boolean
  error?: boolean
  stale?: boolean
}

export function TextRecordPropertyInput (props: TextRecordPropertyInputProps) {
  const { collectionId, field, record, disabled, error, stale } = props

  const property = record.properties[field.id] as TextRecordProperty | undefined

  const [value, setValue] = useState(property?.text?.value ?? '')

  useEffect(() => {
    setValue(property?.text?.value ?? '')
  }, [record])

  const sendValue = (value: string) => {
    props.onUpdateRecordProperties?.({
      recordId: record.id,
      collectionId,
      properties: {
        [field.id]: {
          type: 'text',
          text: {
            value: value || null
          }
        }
      }
    })
  }

  return (
    <div>
      <textarea
        disabled={disabled || error || stale}
        className={clsx(
          'textarea textarea-bordered w-full',
          (stale || error) && '!border-none',
          (stale && !error) && 'custom-bg-stale',
          error && 'custom-bg-error'
        )}
        value={value}
        onChange={event => { setValue(event.target.value) }}
        onKeyDown={event => {
          if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault()
            sendValue(value)
          }
        }}
        onBlur={() => sendValue(value)}
      />
    </div>
  )
}
